import Sales from "./Sales";
import SalesDetails from "./Sales2";
import Sales3 from "./Sales3";
const sales ={
     Sales,
     SalesDetails,
     Sales3
}
export default sales